export const ASSIGNMENT_SETTINGS_TAB = Object.freeze({
    DESCRIPTION: 'description',
    GRADING: 'grading',
    FEEDBACK: 'feedback',
    FORMATIVE: 'formative',
    INLINE_COMMENTS: 'inline-comments',
});

export const ASSIGNMENT_EDITOR_ACTION = Object.freeze({
    SAVE: 'save',
    PUBLISH: 'publish',
    UNPUBLISH: 'unpublish',
});

export const ASSIGNMENT_VALIDATION_REASON = Object.freeze({
    PENDING_DRAFT: 'pending-draft',
});

export const ASSIGNMENT_VALIDATION_RESULT = Object.freeze({
    INVALID: 'invalid',
    FAILED: 'failed',
    SUCCESS: 'success',
});

export const ASSIGNMENT_VALIDATION_FIELDS = Object.freeze([
    {
        field: 'title',
        tab: ASSIGNMENT_SETTINGS_TAB.DESCRIPTION,
        labelKey: 'validation-fields.title',
        fallback: 'Assignment title',
    },
    {
        field: 'description',
        tab: ASSIGNMENT_SETTINGS_TAB.DESCRIPTION,
        labelKey: 'validation-fields.description',
        fallback: 'Assignment description',
    },
    {
        field: 'rubric',
        tab: ASSIGNMENT_SETTINGS_TAB.DESCRIPTION,
        labelKey: 'validation-fields.rubric',
        fallback: 'Assignment rubric',
    },
    {
        field: 'gradingSettings',
        tab: ASSIGNMENT_SETTINGS_TAB.GRADING,
        labelKey: 'validation-fields.grading',
        fallback: 'Grading settings',
    },
    {
        field: 'feedbackSettings',
        tab: ASSIGNMENT_SETTINGS_TAB.FEEDBACK,
        labelKey: 'validation-fields.feedback',
        fallback: 'Feedback settings',
    },
    {
        field: 'studentFeedbackSettings',
        tab: ASSIGNMENT_SETTINGS_TAB.FORMATIVE,
        labelKey: 'validation-fields.formative',
        fallback: 'Formative feedback settings',
    },
    {
        field: 'inlineCommentsSettings',
        tab: ASSIGNMENT_SETTINGS_TAB.INLINE_COMMENTS,
        labelKey: 'validation-fields.inline-comments',
        fallback: 'Inline comments settings',
    },
]);

export const getFirstInvalidAssignmentTab = (errors = {}) => {
    return ASSIGNMENT_VALIDATION_FIELDS.find(({ field }) => errors[field])?.tab || null;
};

export const hasAssignmentSettingsTabError = (tab, errors = {}) =>
    ASSIGNMENT_VALIDATION_FIELDS.some(({ field, tab: fieldTab }) => fieldTab === tab && Boolean(errors[field]));

export const getAssignmentValidationItems = (errors = {}, translate) =>
    ASSIGNMENT_VALIDATION_FIELDS.filter(({ field }) => errors[field]).map(({ field, labelKey, fallback }) => ({
        key: field,
        hasError: errors[field],
        label: translate(labelKey, fallback),
    }));
